// export const baseUrl = 'https://us-central1-personal-projects-380904.cloudfunctions.net/equippedServer/';
export const baseUrl = 'https://us-central1-projects2023-386423.cloudfunctions.net/equippedServer/'
// export const imageUrl = 'https://storage.googleapis.com/buckettom-equipped/'
export const imageUrl = 'https://us-central1-projects2023-386423.cloudfunctions.net/equippedServer/images/'